export default "__VITE_ASSET__CnfFBsnP__"